import DeepAnalysisResult from "@/domain/entities/vistassistant/DeepAnalysisResult";
import type { AppEvents } from "@cs_teamwaydev/mailvista-sdk_react";

// Keeps the userRequestId sent by the SDK: the result belongs to that answer (F-0.5).
const deepAnalysisResultMapper = ({
    userRequestId,
    result,
}: AppEvents["analysis-agent-success"]): DeepAnalysisResult =>
    new DeepAnalysisResult({
        userRequestId,
        result,
    });

export default deepAnalysisResultMapper;
